var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(6071 8669)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(-6071 -8669)",
    fill: "#7898ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-archive-151419",
    d: "M123.577,38.184a2.667,2.667,0,0,0-2.667,2.667v8a1.33,1.33,0,0,0,1.33,1.33h9.34a1.33,1.33,0,0,0,1.33-1.33v-8a2.667,2.667,0,0,0-2.667-2.667Zm-.334.667c-.333,0-.754.441-.754.441-.136.125-.1.226.087.226h8.669c.183,0,.223-.1.087-.226,0,0-.421-.441-.754-.441h-7.333Zm3,4a.665.665,0,0,0-.666.667v.667h2.667v-.667a.665.665,0,0,0-.666-.667Zm.242,4.823a.534.534,0,0,0,.851,0l2.482-2.979c.235-.282.126-.511-.238-.511H124.24c-.367,0-.472.229-.238.511Z",
    transform: "translate(-6184.91 -8700.184)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.adcb61e1c9e3052c413cb8f6194d31c0.svg";
export { ForwardRef as ReactComponent };